import NavSideBar from "../component/NavSideBar";

export default function Others() {
  return (
    <NavSideBar>
        <div className="p-10 text-3xl font-bold">Others</div>
    </NavSideBar>
  )
}
